import './../../style.css';

import * as React from 'react';
import Modal from 'react-responsive-modal';

import { ISetSlotRouterItemFront } from '../../../../actions';
import { IBudget } from '../../../../types/store/budget';
import { IRouterData, IRouterSlot } from '../../../../types/store/routerData';
import { ISlotItem, ISlotsItems } from '../../../../types/store/slotsItems';
import { getSlotItem } from '../../../../utils/manageBudgetSlots';
import ImgSlotItem from '.././ImgSlotItem';
import { ModalItems } from '.././ModalItems';
import { getAllItemsWithDisabled } from '../../../../utils/manageRouterSlots';

interface IFrontPanelProps {
  routerData: IRouterData;
  budget: IBudget;
  slotsItems: ISlotsItems;
  setSlotRouterItem: ISetSlotRouterItemFront;
}

interface IFrontPanelState {
  open: boolean;
  routerSlotClickedElement: IRouterSlot;
  slotItemClickedElement: ISlotItem;
}

class FrontPanel extends React.Component<IFrontPanelProps, IFrontPanelState> {
  constructor(props: IFrontPanelProps) {
    super(props);
    this.state = {
      open: false,
      routerSlotClickedElement: this.props.routerData.slots.front.slotsSpecs[0],
      slotItemClickedElement: this.props.slotsItems[
        this.props.budget.slots.front.slotsSpecs[0]
          ? this.props.budget.slots.front.slotsSpecs[0].filled
          : this.props.slotsItems[Object.keys(this.props.slotsItems)[0]].id
      ]
    };
  }

  onOpenModal = (routerSlotClickedElement: IRouterSlot, slotItemClickedElement: ISlotItem) => {
    this.setState({
      open: true,
      routerSlotClickedElement,
      slotItemClickedElement
    });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onClickModalWrapper = (slotRouterName: string, slotItemName: string) => {
    this.props.setSlotRouterItem(slotRouterName, slotItemName);
    this.setState({ open: false });
  };

  render() {
    const { open, routerSlotClickedElement, slotItemClickedElement } = this.state;
    const { routerData, budget, slotsItems } = this.props;
    return (
      <div className="section swith-front box-rounded bg-grey col-md-12 col-xxl-6">
        <h3 className="section-title ">Switch front view</h3>
        <div className="dragdrop-message d-none d-md-block">
          <p>Add new port cards or modify existing port cards here.</p>
        </div>
        <div className="frontview-container">
          <img src="/LandingsNew/M4300-96X-configurator/imagesswitch/switch-front.png" alt="" />
          <div className="slot-container">
            {routerData.slots.front.slotsSpecs.map(routerSlot => {
              const slotItem = getSlotItem(routerSlot.name, budget.slots.front.slotsSpecs, slotsItems);
              return (
                <ImgSlotItem
                  key={`port-view-${routerSlot.name}`}
                  routerSlot={routerSlot}
                  slotItem={slotItem}
                  onClick={this.onOpenModal}
                />
              );
            })}
          </div>
          <Modal open={open} onClose={this.onCloseModal} little={true}>
            <h5>Select Ports</h5>
            <ModalItems
              routerSlot={routerSlotClickedElement}
              onClick={this.onClickModalWrapper}
              allSlotsItems={getAllItemsWithDisabled(
                this.props.slotsItems,
                routerSlotClickedElement,
                slotItemClickedElement,
                'PORT'
              )}
            />
          </Modal>
        </div>
      </div>
    );
  }
}

export default FrontPanel;



// WEBPACK FOOTER //
// ./src/components/Configurator/ModalConfigurator/FrontPanel/index.tsx